import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { API_BASE_URL } from "../../configuration";

const initialFormValue = {
  medicion: [ '2020', '2021', '2022', '2023','2024','2025'],
  edad_hasta: '',
  edad_desde: '',
  name_gender: '',
  name_region: '',
  name_gse: '',
}

const genderList = [
  { value: "", label: 'Todos'},
  { value: "2", label: 'Mujer'},
  { value: "1", label: 'Hombre'},
]

const ageRangeList = [
  { value: "", label: 'Todos'},
  { value: '25-34', label: '25-34' },
  { value: '35-54', label: '35-54' },
  { value: '55 y más', label: '55 y más' },
]

const DashboardForm = ({ setOnSearch, updateFilters }) => {
  const isMounted = useRef(false)
  const [selectGender, setSelectGender] = useState(genderList[0])
  const [selectRegion, setSelectRegion] = useState({ value: '', label: 'Todos' })
  const [selectAgeRange, setSelectAgeRange] = useState(ageRangeList[0])
  const [selectGse, setSelectGse] = useState({ value: '', label: 'Todos' })

  // respuestas de la API
  const [regionList, setRegionList] = useState([])
  const [gseList, setgseList] = useState([])

  const HandleChangeSelectGender = (selectedOptionMulti) => {
    const { value, label } = selectedOptionMulti;
    setSelectGender({ value, label });
    updateFilters(prev => ({ ...prev, name_gender: value})) 
  };

  const HandleChangeSelectRegion = (selectedOptionMulti) => {
    const { value, label } = selectedOptionMulti;  
    setSelectRegion({ value, label } );
    updateFilters(prev => ({ ...prev, name_region: value}))        
  };

  const HandleChangeSelectGse = (selectedOptionMulti) => {
    const { value, label } = selectedOptionMulti;
    setSelectGse({ value, label } );
    updateFilters(prev => ({ ...prev, name_gse: value}))    
  }

  const HandleChangeSelectAgeRange = (selectedOptionMulti) => {
    const { value, label } = selectedOptionMulti;
    setSelectAgeRange({ value, label });
    updateFilters(prev => ({ ...prev, name_agerange: value}))    
  }

  const loadRegions = async () => {
    try {
      const response = await axios({ url: API_BASE_URL+'/get-regions', method: 'GET' });
      if(response.data.ok){
        if(isMounted.current){
          const regions = response.data.regions || [];
          const regionObj = regions.map(reg => ({ value: reg.VALUE , label: reg.LABEL}));
          setRegionList([ { value:'', label: 'Todos' }, ...regionObj]);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const loadGse = async () => {
    try {
      const response = await axios({ url: API_BASE_URL+'/get-gselist', method: 'GET' });
      if(response.data.ok){
        if (isMounted.current) {
          const gselist = response.data.gse || [];
          const gseObj = gselist.map((reg, i)=> ({ value: reg.VALUE , label: reg.LABEL}));
          setgseList([ { value:'', label: 'Todos' }, ...gseObj ]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handlerSubmitForm = (e) => {
    e.preventDefault();
    setOnSearch(true);
  };

  const handlerResetForm = () => {
    updateFilters(initialFormValue);
    // se restablecen los estados del formulario.
    setSelectGender(genderList[0]);
    setSelectAgeRange(ageRangeList[0]);
    setSelectRegion({ value: '', label: 'Todos' });
    setSelectGse({ value: '', label: 'Todos' });
    setOnSearch(true);
  }

  useEffect(() => {
    isMounted.current = true;
    loadRegions();
    loadGse();
    return () => {
      isMounted.current = false;
    };
  }, [ ])

  return (
    <div className="row mb-0">
      <div className="col-md-12 col-xs-12">
        <div className="cardbox">
          <div className="card-header d-flex justify-content-between align-items-center">
            <span className="text-muted">Filtros</span>
          </div>
          <div className="cardbox-body">
            <form onSubmit={ handlerSubmitForm }>
              <div className="form-row">
                <div className="col-lg-3 col-md-3 col-xs-12">
                  <div className="form-group">
                    <label className="col-form-label label-form">Region:</label>
                    <Select
                      name="region"
                      options={regionList}
                      onChange={HandleChangeSelectRegion}
                      value={selectRegion}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-xs-12">
                  <div className="form-group">
                    <label className="col-form-label label-form">Genero:</label>
                    <Select
                      name="gender"
                      options={genderList}
                      onChange={HandleChangeSelectGender}
                      value={selectGender}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-xs-12">
                  <div className="form-group">
                    <label className="col-form-label label-form">Gse:</label>
                    <Select
                      name="gse"
                      options={gseList}
                      onChange={HandleChangeSelectGse}
                      value={selectGse}
                    />
                  </div>
                </div>

                <div className="col-lg-3 col-md-3 col-xs-12">
                  <div className="form-group">
                    <label className="col-form-label label-form">Rango de edad:</label>
                    <Select
                      name="ageRange"
                      placeholder="Seleccione"
                      options={ageRangeList}
                      onChange={HandleChangeSelectAgeRange}
                      value={selectAgeRange}
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-lg-12 col-md-12 col-xs-12">&nbsp;</div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-xs-12">
                  <button
                    className="btn-square mr ripple btn float-left"
                    style={{ background: '#53565A', color: 'white' }}
                    type="button"
                    onClick={ handlerResetForm }
                  >
                    Limpiar
                  </button>
                  <button
                    className="btn-square mr ripple btn float-left"
                    style={{ background: '#00BFB3', color: 'white' }}
                    type="submit"
                  >
                    Filtrar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardForm;
